import React from 'react';
 import Icon from'@/components/ui/AppIcon';

const ContactSection: React.FC = () => {
  const handleWhatsAppClick = () => {
    window.open(
      'https://wa.me/243996739468?text=Hello, I would like to inquire about gold export services.',
      '_blank'
    )
  }

  const handleEmailClick = () => {
    window.location.href = 'mailto:info@mulumbuminerals.com'
  }

  return (
    <section className="py-24 md:py-32 px-6 md:px-12 bg-background">
      <div className="w-full max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 reveal">
          <span className="text-xs font-body font-bold uppercase tracking-[0.4em] text-muted-foreground mb-4 block">
            Get in Touch
          </span>
          <h2 className="text-5xl md:text-6xl font-display font-bold tracking-tight text-foreground mb-4">
            Contact Us Today
          </h2>
          <p className="text-lg text-muted-foreground font-body max-w-2xl mx-auto">
            Ready to start your gold export journey? Reach out via WhatsApp for instant support.
          </p>
        </div>

        {/* Split Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Contact Info */}
          <div className="reveal">
            <div className="glass-card p-10 rounded-3xl border border-border shadow-xl hover-lift transition-smooth">
              {/* Primary Contact: WhatsApp */}
              <div className="mb-8">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-xl bg-[#25D366]/10 flex items-center justify-center transition-smooth hover:scale-110 hover:bg-[#25D366]/20">
                    <Icon name="ChatBubbleLeftRightIcon" size={24} className="text-[#25D366]" />
                  </div>
                  <span className="text-sm font-body font-bold uppercase tracking-wider text-muted-foreground">
                    Primary Contact
                  </span>
                </div>
                <button
                  onClick={handleWhatsAppClick}
                  className="group w-full px-8 py-4 bg-[#25D366] text-white rounded-full font-body font-semibold text-lg shadow-lg hover:shadow-2xl transition-smooth hover:scale-105 hover-glow flex items-center justify-center gap-3"
                >
                  <Icon name="ChatBubbleLeftRightIcon" size={24} />
                  <span>+243 996 739 468</span>
                  <Icon
                    name="ArrowRightIcon"
                    size={20}
                    className="group-hover:translate-x-1 transition-transform"
                  />
                </button>
                <p className="text-sm font-body text-muted-foreground mt-3 text-center">
                  Typically responds within 1 hour
                </p>
              </div>

              {/* Email */}
              <div className="mb-8">
                <div className="flex items-center gap-3 mb-3">
                  <Icon name="EnvelopeIcon" size={20} className="text-primary" />
                  <span className="text-sm font-body font-medium text-muted-foreground">Email</span>
                </div>
                <button
                  onClick={handleEmailClick}
                  className="text-lg font-body text-foreground hover:text-primary transition-smooth underline hover:scale-105 inline-block"
                >
                  info@mulumbuminerals.com
                </button>
              </div>

              {/* Location */}
              <div className="mb-8">
                <div className="flex items-center gap-3 mb-3">
                  <Icon name="MapPinIcon" size={20} className="text-primary" />
                  <span className="text-sm font-body font-medium text-muted-foreground">
                    Location
                  </span>
                </div>
                <p className="text-lg font-body text-foreground">
                  North Kivu, Butembo
                  <br />
                  Democratic Republic of Congo
                </p>
              </div>

              {/* Operating Hours */}
              <div className="mb-8">
                <div className="flex items-center gap-3 mb-3">
                  <Icon name="ClockIcon" size={20} className="text-primary" />
                  <span className="text-sm font-body font-medium text-muted-foreground">
                    Operating Hours
                  </span>
                </div>
                <p className="text-base font-body text-foreground">
                  Monday - Saturday
                  <br />
                  8:00 AM - 6:00 PM (CAT)
                </p>
              </div>

              {/* Languages with Enhanced Hover */}
              <div>
                <div className="flex items-center gap-3 mb-3">
                  <Icon name="LanguageIcon" size={20} className="text-primary" />
                  <span className="text-sm font-body font-medium text-muted-foreground">
                    Languages
                  </span>
                </div>
                <div className="flex gap-2">
                  <span className="px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-body font-medium transition-smooth hover:bg-primary hover:text-primary-foreground hover:scale-110 cursor-pointer">
                    English
                  </span>
                  <span className="px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-body font-medium transition-smooth hover:bg-primary hover:text-primary-foreground hover:scale-110 cursor-pointer">
                    French
                  </span>
                  <span className="px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-body font-medium transition-smooth hover:bg-primary hover:text-primary-foreground hover:scale-110 cursor-pointer">
                    Swahili
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Map with Enhanced Hover */}
          <div className="reveal">
            <div className="glass-card p-4 rounded-3xl border border-border shadow-xl overflow-hidden h-[600px] hover-lift transition-smooth">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d127481.54822638945!2d29.289394!3d0.141667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x176fb1f7c3a5a5a5%3A0x1234567890abcdef!2sButembo%2C%20Democratic%20Republic%20of%20the%20Congo!5e0!3m2!1sen!2sus!4v1234567890123"
                width="100%"
                height="100%"
                style={{ border: 0, borderRadius: '1.5rem' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mulumbu Minerals Location - Butembo, North Kivu, DRC"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactSection